import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
}));
const Container = styled('div')(() => ({
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
const CenteredLayout = ({ children }) => (_jsx(Root, { children: _jsx(Container, { children: children }) }));
export default CenteredLayout;
//# sourceMappingURL=index.js.map